// Modal Popups
export const setModalOpen = '@announcements/setModalOpen';
export const setModalType = '@announcements/setModalType';
export const setModalAction = '@announcements/setModalAction';
// Published, Draft
export const setStatus = '@announcements/setStatus';
// Starred
export const setStarred = '@announcements/setStarred';
// Deleted
export const setDeleted = '@announcements/setDeleted';
// Current selected item
export const setSelectedItem = '@announcements/setSelectedItem';
// Currently seleected attachment
export const setAttachment = '@announcements/setAttachment';
// Currently seleected attachment size
export const setAttachmentSize = '@announcements/setAttachmentSize';
// Currently seleected attachment pages
export const setAttachmentTotalPages = '@announcements/setAttachmentTotalPages';
// All items for list
export const setItems = '@announcements/setItems';
// Set media status
export const setMedia = '@announcements/setMedia';
// Pagination Params
export const setCurrentPage = '@announcements/setCurrentPage';
export const setItemsPerPage = '@announcements/setItemsPerPage';
export const setPaginationMeta = '@announcements/setPaginationMeta';
// Reload
export const setReload = '@announcements/setReload';
// Draft Counts
export const setDraftCount = '@announcements/setDraftCount';
export const setSelectedNewItem = '@announcements/setSelectedNewItem';
export const setSelectedIds = '@announcements/setSelectedIds';
export const setCloseModalOpen = '@announcements/setCloseModalOpen';
export const setUploadingMedia = '@announcments/setUploadingMedia';
export const setPublishingBox = '@announcments/setPublishingBox';
export const setAbortControllers = '@announcments/setAbortControllers';
